import Api from '@/api/Api';
import uploadWithAuth from '@/api/ApiUpload';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_NAME = '/api/employees';


export default {

    // EMPLOYEES
    async get(resource){
        return Api()
            .get(resource)
            .catch((err) => errorHandler(err, null));
    },
    getEmployees(params) {
        return Api()
            .get(RESOURCE_NAME, { params: params })
            .catch((err) => errorHandler(err, null));
    },
    getSystemEmployees(params) {
        return Api()
            .get(RESOURCE_NAME+'?active=1&job.name=Administrador de Sistemas', { params: params })
            .catch((err) => errorHandler(err, null));
    },
    getEmployee(id, options = {}) {
        return Api().get(RESOURCE_NAME + `/${id}`, { signal: options.signal })
            .catch((err) => { if (options.silent) throw err; return errorHandler(err, null); });
    },
    // Ficha mínima (sin datos personales) de un miembro del equipo: la completa solo la ven admin/employees:view/uno mismo.
    getTeamMember(id, options = {}) {
        return Api().get(RESOURCE_NAME + `/${id}/team_member`, { signal: options.signal })
            .catch((err) => { if (options.silent) throw err; return errorHandler(err, null); });
    },
    createEmployee(item) {
        return Api().post(RESOURCE_NAME, item)
            .catch((err) => errorHandler(err, null));
    },
    updateEmployee(item, id) {
        return Api().put(RESOURCE_NAME + `/${id}`, item)
            .catch((err) => errorHandler(err, null));
    },
    deleteEmployee(id) {
        return Api().delete(RESOURCE_NAME + `/${id}`)
            .catch((err) => errorHandler(err, null));
    },
    changePhoto(employeeId, file) {
        const formData = new FormData();
        formData.append('file', file);
        return uploadWithAuth({
            method: 'post',
            url: process.env.VUE_APP_API_URI + `/employees/${employeeId}/photo`,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            },
            errorHandle: false,
        });
    },

}

